import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1.5 text-sm">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className="text-foreground-500 hover:text-primary-700 cursor-pointer transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "text-foreground-900 font-semibold" : "text-foreground-500"}>
                {item.label}
              </span>
            )}
            {!isLast && (
              <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true"></i>
            )}
          </span>
        );
      })}
    </nav>
  );
}